module.exports = __webpack_public_path__ + "assets/img/title-6fbd77c4.png";